import { render } from "./tabsMs.vue?vue&type=template&id=2a261daa"
import script from "./tabsMs.vue?vue&type=script&lang=js"
export * from "./tabsMs.vue?vue&type=script&lang=js"

import "./tabsMs.vue?vue&type=style&index=0&id=2a261daa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__